import Typography, { type TypographyProps } from "@mui/joy/Typography"

const SpotlightDialogTitle = (props: TypographyProps) => {
  return <Typography level="body-sm" textColor="text.tertiary" {...props} />
}

export default SpotlightDialogTitle
